import { ClientSettings } from '@/dto';
import {
    IClientSettingsChangeServiceData,
} from '../settingsChangeServiceContract';
import { updateTableHeaderWrap } from '@/core/components/table/tableHelpers';

export class ClientSettingsChangeServiceData implements IClientSettingsChangeServiceData {
    public enableNotifications: boolean;
    public enableGroupNotifications: boolean;
    public saveTileState: boolean;
    public colorIndication: boolean;
    public autoReconnect: boolean;

    public get enableTableColumnHeaderWordWrap(): boolean {
        updateTableHeaderWrap();
        return this._enableTableColumnHeaderWordWrap;
    }

    public set enableTableColumnHeaderWordWrap(value) {
        this._enableTableColumnHeaderWordWrap = value;
    }

    private _enableTableColumnHeaderWordWrap: boolean = false;

    constructor(data: ClientSettings) {
        this.enableNotifications = data.enableNotifications || false;
        this.enableGroupNotifications = data.enableGroupNotifications || false;
        this.saveTileState = data.saveTileState || false;
        this.colorIndication = data.colorIndication || false;
        this.enableTableColumnHeaderWordWrap = data.enableTableColumnHeaderWordWrap || false;
        this.autoReconnect = data.autoReconnect === undefined ? true : data.autoReconnect;
    }
}
